// @ts-nocheck
import { PageLinkModel } from "@insite/client-framework/Services/ContentService";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import React, { FC } from "react";
import { css } from "styled-components";

export interface LinkToPresentationProps extends ExpandStyles<LinkToStyles> {}

export interface LinkToProps extends LinkToPresentationProps {
    title?: string;
    pageLink?: PageLinkModel;
    pageIdSegment?: string;
    onClick?: () => void;
    openInNewTab?: boolean;
}

export interface LinkToStyles {
    link?: LinkPresentationProps;
}

export const linkToStyles: LinkToStyles = {
    link: {
        mergeCss: true,
        css: css`
            font-weight: ${x => x.theme.design.typography.weight.medium};
        `,
    },
};

const LinkTo: FC<LinkToProps> = ({
    title,
    extendedStyles,
    overridedStyles,
    pageLink,
    pageIdSegment,
    openInNewTab,
    onClick,
}) => {
    const styles = useExpandProps(linkToStyles, extendedStyles, overridedStyles);
    const mergeUrls = pageIdSegment ? `${pageLink?.url || ""}${pageIdSegment}` : pageLink?.url;

    if (!pageLink?.url) {
        return null;
    }

    return (
        <Link {...styles.link} href={mergeUrls} onClick={onClick} target={openInNewTab ? "_blank" : undefined}>
            {title || pageLink?.title}
        </Link>
    );
};

export default LinkTo;
